import baseApi from 'shared/api/baseApi';

import type { ConversationImportResponse } from '../model/conversationImport';

const conversationsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    importConversation: build.query<ConversationImportResponse, { projectId: number; q: string }>({
      query: ({ projectId, q }) => ({
        url: '/admin/agentEvals/conversations',
        method: 'GET',
        params: { projectId, q },
      }),
      keepUnusedDataFor: 0,
    }),
  }),
  overrideExisting: false,
});

export const { useLazyImportConversationQuery } = conversationsApi;
